import { Controller } from "@hotwired/stimulus"
import JustValidate from "just-validate"
import { applyPendingAuthContinuation } from "./support/auth_continuation"

// data-controller="signup"
export default class extends Controller {
    connect() {
        const prefix = `#${this.element.id}`
        const selector = (name) => `${prefix} [name="account[${name}]"]`
        const countrySelector = selector("country")
        this.countryInput = this.element.querySelector('[name="account[country]"]')
        this.countryError = this.element.querySelector("[data-signup-country-error]")

        this.validator = new JustValidate(this.element, { validateBeforeSubmitting: true })
        this.validator
            .addField(selector("first_name"), [{ rule: "required", errorMessage: "First name is required" }])
            .addField(selector("last_name"), [{ rule: "required", errorMessage: "Last name is required" }])
            .addField(selector("username"), [
                { rule: "required", errorMessage: "Email address is required" },
                { rule: "email", errorMessage: "Please enter a valid email" }
            ])
            .addField(
                countrySelector,
                [{ rule: "required", errorMessage: "Please select a country" }],
                this.countryError ? { errorsContainer: this.countryError } : undefined
            )
            .addField(selector("password"), [
                { rule: "required", errorMessage: "Password is required" },
                { rule: "minLength", value: 6, errorMessage: "Password must be at least 6 characters" },
                { rule: "maxLength", value: 128, errorMessage: "Password must be no more than 128 characters" }
            ])
            .onSuccess((event) => {
                window.echoageSetupDiagnostics?.report?.('signup_submit')
                applyPendingAuthContinuation(event.target)
                event.target.submit()
            })
            .onFail(() => window.echoageSetupDiagnostics?.report?.('signup_validation_blocked', 'validation'))

        this.countryChangeHandler = () => {
            if (!this.countryInput?.value) return
            this.countryInput.parentElement?.classList.remove("error")
            if (this.countryError) this.countryError.textContent = ""
        }
        this.countryInput?.addEventListener("change", this.countryChangeHandler)
    }

    disconnect() {
        this.countryInput?.removeEventListener("change", this.countryChangeHandler)
        this.validator?.destroy?.()
    }
}
